module.exports = {
      id: "video-usage",
      viewBox: "0 0 104 104",
      url: __webpack_public_path__ + "svg-sprite-dd330238154521d0397e6121ac041d84.svg#video",
      toString: function () {
        return this.url;
      }
    }